import _ from 'lodash';

import {
  addPendingRequestIdForConversation,
  clearPendingRequest,
} from 'actions/composition/lib/update_conversation_workflow';
import Attachment from 'models/attachment';
import createConversationMessage from 'models/create_conversation_message';
import CreateInstagramComposition from './create_instagram_composition';
import CreateTweetComposition from 'actions/composition/create_tweet_composition';
import CreateWhatsappComposition from 'actions/composition/create_whatsapp_composition';
import Err from 'models/err';
import IdGenerator from 'scripts/domain/contracts/id_generator';
import { isEmpty } from 'models/composition/composition_content_shared';
import InteractionType from 'models/composition/interaction_type';
import SubmitComposition, { getOutgoingItemDto } from 'actions/composition/lib/submit_composition';
import Upload from 'models/upload';

export default class SendConversationMessage extends SubmitComposition {
  sendMessage(conversationUpdates, conversationMessageItem) {
    // mark the request as pending in the conversation workflow
    const requestId = IdGenerator.newId();
    addPendingRequestIdForConversation(this.context, conversationMessageItem.conversationId, requestId);

    this.context.gateways.conversationMessage
      .add({
        id: conversationMessageItem.id,
        customerId: this.currentCustomerId,
        conversation: conversationUpdates,
        conversationItem: getOutgoingItemDto(conversationMessageItem),
      })
      .finally(() => {
        clearPendingRequest(this.context, requestId);
      });
  }

  createOutgoingItem(composition, content) {
    if (isEmpty(content.bodyHtml)) {
      return {
        compositionErrors: [
          new Err({
            attr: 'body',
            code: Err.Code.BLANK,
            detail: `editor is empty`,
          }),
        ],
      };
    }

    const conversationMessageItem = createConversationMessage(
      this.currentAgent,
      composition.attachments,
      content,
      this.activeConversation.id,
      composition.customerId,
      composition.snippetIds,
      composition.relatedSnippetIds
    );

    return { compositionErrors: [], conversationItem: conversationMessageItem };
  }

  createConversationMessageAttachments(composition) {
    return composition.attachments.map(attachment => asConversationMessageAttachment(composition, attachment));
  }

  getConversationUpdates(conversation) {
    return _.assign(
      super.getConversationUpdates(conversation),
      conversation.getUpdatedAttributesForRealtimeCommunication(this.currentAgent.id)
    );
  }

  afterSend(content) {
    // create a new conversation message to continue talking with the customer
    switch (content.content.channel) {
      case InteractionType.TWITTER:
        this.context.executeAction(CreateTweetComposition, { conversationId: this.activeConversation.id });
        break;
      case InteractionType.WHATSAPP:
        this.context.executeAction(CreateWhatsappComposition, { conversationId: this.activeConversation.id });
        break;
      case InteractionType.INSTAGRAM_DIRECT:
        this.context.executeAction(CreateInstagramComposition, { conversationId: this.activeConversation.id });
        break;
    }
  }
}

function asConversationMessageAttachment(composition, attachment) {
  let fileDescriptor = attachment.fileDescriptor();
  let source = attachment instanceof Upload ? createUploadSource(composition, attachment.id) : attachment.source;

  return Attachment.create({
    id: attachment.id,
    contentType: fileDescriptor.contentType,
    filename: fileDescriptor.filename,
    fileSize: fileDescriptor.contentLength,
    source,
  });
}

function createUploadSource(composition, attachmentId) {
  return {
    type: Attachment.SourceType.UPLOAD,
    path: composition.getUploadPath(attachmentId),
  };
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/composition/send_conversation_message.js